import {
    createHashHistory
} from 'history';

const getHistory = () => {
    return createHashHistory();
}

export const history = getHistory();